import { Phoneme } from "./phoneme";
import { Grapheme } from "./grapheme";
import { Word } from "./word";
import { Phrase } from "./phrase";
import { Sentence } from "./sentence";
import { Letter } from "./letter";
import { Numeral } from "./numeral";

export function DefineCustomElements() {

  customElements.define("span-phoneme", Phoneme);
  customElements.define("span-grapheme", Grapheme);
  customElements.define("span-letter", Letter);
  customElements.define("span-word", Word);
  customElements.define("span-phrase", Phrase);
  customElements.define("span-sentence", Sentence);
  customElements.define("span-numeral", Numeral);
}
